import {
  ApiKeysActions,
  ApiKeysReducerState,
  CREATE_API_KEYS_COMPLETE,
  CREATE_API_KEYS_IS_ERROR,
  CREATE_API_KEYS_IS_PENDING,
  DELETE_API_KEYS_COMPLETE,
  DELETE_API_KEYS_IS_ERROR,
  DELETE_API_KEYS_IS_PENDING,
  EDIT_API_KEYS_COMPLETE,
  EDIT_API_KEYS_IS_ERROR,
  EDIT_API_KEYS_IS_PENDING,
  FETCH_API_KEYS_IS_COMPLETE,
  FETCH_API_KEYS_IS_ERROR,
  FETCH_API_KEYS_IS_PENDING,
  SORT,
} from 'services/Account/APIKeys/types';
import { addNew, sort } from 'utils/functions';

const INITIAL_STATE = {
  apiKeys: [],
  sortBy: 'key',
  sortDirection: 'ASC',
  params: undefined,
  fetchIsCompleted: false,
  fetchIsPending: false,
  fetchIsError: null,
  createIsCompleted: false,
  createIsPending: false,
  createIsError: null,
  editIsCompleted: false,
  editIsPending: false,
  editIsError: null,
  deleteIsCompleted: false,
  deleteIsPending: false,
  deleteIsError: null,
} satisfies ApiKeysReducerState;

const accountApiKeysReducer = (previousState: ApiKeysReducerState | undefined, action: ApiKeysActions): ApiKeysReducerState => {
  const state: ApiKeysReducerState = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case FETCH_API_KEYS_IS_COMPLETE:
      return {
        ...state,
        apiKeys: sort(action.data ?? [], {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: state.params?.sortSearchValue ?? state.params?.value,
        }),
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case FETCH_API_KEYS_IS_PENDING:
      return {
        ...state,
        fetchIsCompleted: false,
        fetchIsPending: true,
        fetchIsError: null,
      };
    case FETCH_API_KEYS_IS_ERROR:
      return {
        ...state,
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: action.error,
      };

    case CREATE_API_KEYS_COMPLETE:
      return {
        ...state,
        apiKeys: addNew(action.data, state.apiKeys),
        createIsCompleted: true,
        createIsPending: false,
        createIsError: null,
      };
    case CREATE_API_KEYS_IS_PENDING:
      return {
        ...state,
        createIsCompleted: false,
        createIsPending: true,
        createIsError: null,
      };
    case CREATE_API_KEYS_IS_ERROR:
      return {
        ...state,
        createIsCompleted: true,
        createIsPending: false,
        createIsError: action.error,
      };

    case EDIT_API_KEYS_COMPLETE: {
      const update = action.data;

      if (!update) {
        return { ...state, editIsCompleted: true, editIsPending: false, editIsError: 'no data found' };
      }

      return {
        ...state,
        apiKeys: state.apiKeys.map((item) => {
          if (item.id !== update.id) {
            return item;
          }

          return {
            ...item,
            ...update,
          };
        }),
        editIsCompleted: true,
        editIsPending: false,
        editIsError: null,
      };
    }

    case EDIT_API_KEYS_IS_PENDING:
      return {
        ...state,
        editIsCompleted: false,
        editIsPending: true,
        editIsError: null,
      };
    case EDIT_API_KEYS_IS_ERROR:
      return {
        ...state,
        editIsCompleted: true,
        editIsPending: false,
        editIsError: action.error,
      };

    case DELETE_API_KEYS_COMPLETE: {
      return {
        ...state,
        apiKeys: state.apiKeys.filter((item) => item.id !== action.data),
        deleteIsCompleted: true,
        deleteIsPending: false,
        deleteIsError: null,
      };
    }

    case DELETE_API_KEYS_IS_PENDING:
      return {
        ...state,
        deleteIsCompleted: false,
        deleteIsPending: true,
        deleteIsError: null,
      };
    case DELETE_API_KEYS_IS_ERROR:
      return {
        ...state,
        deleteIsCompleted: true,
        deleteIsPending: false,
        deleteIsError: action.error,
      };

    case SORT:
      return {
        ...state,
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
        params: action.params,
        apiKeys: sort(state.apiKeys, {
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };
    default:
      return state;
  }
};

export default accountApiKeysReducer;
